import { render, staticRenderFns } from "./Anniversary.vue?vue&type=template&id=137a9498&scoped=true"
import script from "./Anniversary.vue?vue&type=script&lang=js"
export * from "./Anniversary.vue?vue&type=script&lang=js"
import style0 from "./Anniversary.vue?vue&type=style&index=0&id=137a9498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a9498",
  null
  
)

export default component.exports